import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import green from '@material-ui/core/colors/green';

import { startEditBid } from '../../../store/actions/bids';
import { startEditBidState } from '../../../store/actions/bidStatus';
import { startAddProject } from '../../../store/actions/projects';
import { selectBidStatus } from '../../../store/selectors/bidStatus';
import { generateBidPDF } from 'store/generators';
import { startEditPreview } from 'store/actions/preview';

const styles = theme => ({
  root: {
    width: '130px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: theme.spacing.unit,
  },
});


//TODO: implement a pattern for statuses and refactor out of the component
class BidStatus extends Component{
  constructor(props){
    super(props);
    this.state = {
      anchorEl: null,
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      classes,
      bid,
      bidTasks,
      bidState,
      companyInfo,
      client,
      jobCreated,
      startEditBidState,
      startAddProject,
      startEditPreview,
    } = this.props;
    const { anchorEl } = this.state;

    const statusColor = function () {
      if (bidState.statusMessage === undefined) {
        return undefined;
      } else if (bidState.statusMessage.status === undefined) {
        return undefined;
      } else if (bidState.statusMessage.status === "overdue") {
        return red[500];
      } else if (bidState.statusMessage.status === "warning") {
        return orange[500];
      } else if (bidState.statusMessage.status === "ok") {
        return green[500];
      }
    }();

    return(
      <div className={classes.root}>
        <Typography style={{color: statusColor}}>
          {bidState.status}
        </Typography>
        {false && bidState.actions.secondary.length === 0 &&
          <Button color="primary" onClick={() => {
              startEditBidState(bid.id, bidState.actions.primary.state);
          }}>
            {bidState.actions.primary.displayName}
          </Button>
        }
        {(true || bidState.actions.secondary.length !== 0) &&
          <div>
            <Button
              color="primary"
              aria-owns={anchorEl ? 'simple-menu' : null}
              aria-haspopup="true"
              onClick={this.handleClick}
            >
              Action
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem onClick={() => {
                  const newState = bidState.actions.primary.state;
                  const actionType = bidState.actions.primary.actionType;
                  if (actionType === "won") {
                    startAddProject({}, bid, bidTasks)
                    .then((result) => {
                      startEditBidState(bid.id, newState);
                      this.handleClose();
                    })

                  } else if (actionType === "sent") {
                    const pdf = generateBidPDF(bid, bidTasks, companyInfo, client);
                    const toEmail = client.email;

                    pdf.getBlob(blob => {
                      startEditPreview({
                        show: true,
                        data: {
                          title: "Send Bid",
                          type: "send-bid",
                          bid: bid,
                          bidTasks,
                          blob: blob,
                          pdf: pdf,
                          toEmail,
                          client
                        }
                      });
                    });

                    this.handleClose();
                  } else {
                    startEditBidState(bid.id, newState);
                    this.handleClose();
                  }
              }}>
                {bidState.actions.primary.displayName}
              </MenuItem>
              <Divider />
              {bidState.actions.secondary.map((action, i) => (
                <MenuItem key={i} onClick={ () => {
                    const newState = action.state;
                    const actionType = action.actionType;

                    if (actionType === "won" && !jobCreated) {
                      startAddProject({}, bid, bidTasks)
                      .then((result) => {
                        startEditBidState(bid.id, newState);
                        this.handleClose();
                      })

                    } else {
                      startEditBidState(bid.id, newState);
                      this.handleClose();
                    }
                  }}>
                  {action.displayName}
                </MenuItem>
              ))}
            </Menu>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { bid } = props;

  const clients = state.clientsState;

  const account = state.accountState ? state.accountState : {};
  const profile = (account.user && account.user.profile && account.user.profile) ? account.user.profile : {};
  const organization = account.organizations[0] ? account.organizations[0] : {};
  const about = organization.about ? organization.about : {};

  const address = {
    street: about.phone ? about.phone : "",
    city: about.city ? about.city : "",
    province: about.province ? about.province : "",
    country: about.country ? about.country : "",
    postalCode: about.postalCode ? about.postalCode : "",
  };
  const companyInfo = {
    companyPhone: about.phone ? about.phone : "",
    companyEmail: profile.email ? profile.email : "",
    address,
  }

  let client;
  if (bid) {
    client = clients.find((client) => client.id === bid.clientId);
  }

  const project = state.projectsState.find(project => project.bidId === bid.id);

  return {
    bidState: selectBidStatus(state, bid.id),
    companyInfo,
    client,
    jobCreated: project ? true : false ,
  };
}

const mapDispatchToProps = {
  startEditBid,
  startEditBidState,
  startAddProject,
  startEditPreview,
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(BidStatus);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/BidStatus.jsx